import React from 'react';
import { LABELS, SKILL_LIST } from '../constants/enquiryFormOptions';
import { useMediaQuery } from '../hooks/useMediaQuery';

export default function SkillRatingsSection({ register, setValue, watch, getSkillError }) {
  const isDesktop = useMediaQuery('(min-width: 900px)');
  const skillRatings = watch('skillRatings') || [];

  const selectedLevel = (index) => skillRatings[index]?.level || '';

  const renderLevelInputs = (skill, index) => {
    const levelRegister = register(`skillRatings.${index}.level`, {
      required: 'Please select a rating for this skill',
    });

    return Object.keys(LABELS.skillLevel).map((level) => (
      <label key={level} className={isDesktop ? 'skill-radio' : 'skill-level-option'}>
        <input
          type="radio"
          value={level}
          name={levelRegister.name}
          checked={selectedLevel(index) === level}
          onChange={(event) => {
            levelRegister.onChange(event);
            setValue(`skillRatings.${index}.skill`, skill, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
          onBlur={levelRegister.onBlur}
          ref={levelRegister.ref}
        />
        {!isDesktop && <span>{LABELS.skillLevel[level]}</span>}
      </label>
    ));
  };

  if (isDesktop) {
    return (
      <div className="skills-table">
        <div className="skills-header">
          <span>Skill</span>
          {Object.entries(LABELS.skillLevel).map(([k, v]) => (
            <span key={k}>{v}</span>
          ))}
        </div>
        {SKILL_LIST.map((skill, index) => (
          <div
            key={skill}
            className={`skills-row${getSkillError?.(index) ? ' skills-row-error' : ''}`}
          >
            <span className="skill-name">{LABELS.skill[skill]}</span>
            {renderLevelInputs(skill, index)}
            {getSkillError?.(index) && (
              <span className="field-error skills-row-error-msg">{getSkillError(index)}</span>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="skills-mobile">
      {SKILL_LIST.map((skill, index) => (
        <div
          key={skill}
          className={`skill-card${getSkillError?.(index) ? ' skill-card-error' : ''}`}
        >
          <p className="skill-card-title">{LABELS.skill[skill]}</p>
          <div className="skill-level-options">{renderLevelInputs(skill, index)}</div>
          {getSkillError?.(index) && (
            <span className="field-error">{getSkillError(index)}</span>
          )}
        </div>
      ))}
    </div>
  );
}
